module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-list"
  }, [_vm._l((_vm.value), function(image, index) {
    return _c('div', {
      key: image,
      staticClass: "image-item",
      style: (_vm._f("formatbg")(image))
    }, [_c('i', {
      staticClass: "el-icon-delete icon",
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    })])
  }), _vm._v(" "), (_vm.multiple || (!_vm.multiple && !_vm.value.length)) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "image-item"
  }, [_c('i', {
    staticClass: "el-icon-plus icon plus-icon",
    on: {
      "click": _vm.addImage
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadImage
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1de02f97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUploader.vue
// module id = 789
// module chunks = 1